import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: François Risoud
 * id 9D88AEE3-9749-4B74-8F60-2995BD811AAA
 * name refresh-circle
 * version: 4.9.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/refresh-circle.svg
 * tags
 */
export const RefreshCircleIcon = createSvgIcon(<><path d="M12 2A10 10 0 1 0 22 12A10 10 0 0 0 12 2M18 11H13L14.81 9.19A3.94 3.94 0 0 0 12 8A4 4 0 1 0 15.86 13H17.91A6 6 0 1 1 12 6A5.91 5.91 0 0 1 16.22 7.78L18 6Z" /></>, 'RefreshCircleIcon');
export default RefreshCircleIcon